import {DecoBall} from '../../../../../global-styles/deco-styles/deco-ball/DecoBall'
import {useEffect, useRef} from 'react'

export const HeroDeco = () => {
    const ref1 = useRef(null)
    const ref2 = useRef(null)

    useEffect(() => {
        if (!ref1.current) return
        if (!ref1?.current?.setField) return
        ref1?.current?.setField('score-5')
        ref1?.current?.shadowRoot?.querySelector('label')?.remove()
    }, [ref1])

    useEffect(() => {
        if (!ref2.current) return
        if (!ref2?.current?.setField) return
        ref2?.current?.setField('score-10')
        ref2?.current?.shadowRoot?.querySelector('label')?.remove()
    }, [ref2])

    return (
        <>
            <div className={'deco-ball-wrapper'}>
                <DecoBall id={'star-ball'} style={{zIndex: '25'}}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="128" height="127" fill="none">
                        <path
                            d="M45.337 48.248 49.172 6.95l23.971 33.847a9 9 0 0 0 6.513 3.76l41.298 3.836-33.847 23.97a9 9 0 0 0-3.76 6.513l-3.836 41.299L55.54 86.327a9 9 0 0 0-6.512-3.76L7.729 78.732 41.577 54.76a9 9 0 0 0 3.76-6.513Z"
                            stroke="#F0F2F5" strokeWidth="10"/>
                    </svg>
                </DecoBall>
                <DecoBall id={'thumbs-up-ball'} style={{height: '135px', width: '135px', zIndex: '16'}}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="103" height="103" fill="none">
                        <path
                            d="m66.309 87.42-38.896-7.768 9.181-45.969L66.29 13.875l3.537 5.302c.33.495.558 1.123.681 1.883.124.76.122 1.465-.008 2.113l-.247 1.237-6.962 14.605L86.1 43.571c1.885.376 3.394 1.413 4.526 3.11 1.132 1.697 1.51 3.489 1.133 5.374l-1.412 7.072c-.083.413-.23.843-.442 1.291-.212.448-.418.867-.618 1.256l-15.588 22.81c-.766 1.073-1.85 1.898-3.252 2.476-1.403.578-2.782.731-4.137.46ZM35.897 73.993l31.825 6.356 15.552-22.633 1.412-7.072-31.824-6.357 8.658-18.494-18.454 12.31-7.169 35.89Zm.697-40.309-1.413 7.072-10.608-2.119-6.356 31.825 10.608 2.118-1.412 7.073-17.68-3.532 9.18-45.968 17.681 3.531Z"
                            fill="#F0F2F5"/>
                    </svg>
                </DecoBall>
                <DecoBall id={'exclamation-ball'} style={{height: '58px', width: '58px', zIndex: '16'}}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="11" height="31" fill="none">
                        <path
                            d="M7.496 30.803c-.911.11-1.73-.12-2.457-.69a3.212 3.212 0 0 1-1.255-2.221c-.11-.911.12-1.73.69-2.457a3.213 3.213 0 0 1 2.22-1.255c.911-.11 1.73.12 2.457.69a3.212 3.212 0 0 1 1.256 2.22c.11.912-.12 1.73-.69 2.457a3.212 3.212 0 0 1-2.221 1.256Zm-4.513-9.535L.58 1.4l6.623-.8 2.403 19.869-6.623.8Z"
                            fill="#F0F2F5"/>
                    </svg>
                </DecoBall>
                <DecoBall style={{height: '57px', width: '57px', bottom: '-12%', left: '16%', zIndex: 24}}></DecoBall>
                <DecoBall style={{height: '24px', width: '24px', bottom: '-16px', left: '32%', zIndex: 24}}></DecoBall>
                <uxf-field id={'deco-score-5'} ref={ref1}></uxf-field>
                <uxf-field id={'deco-score-10'} ref={ref2}></uxf-field>
            </div>
            <div className={'deco-ball-wrapper on-top'}>
            <DecoBall id={'thumbs-up-ball-2'} style={{height: '52px', width: '52px', zIndex: 24}}></DecoBall>
                <DecoBall id={'thumbs-up-ball-3'}  style={{height: '24px', width: '24px', zIndex: 24}}></DecoBall>
            </div>
        </>
    )
}